export default {"LABEL":"Installation 安装","DESC":"2O3T 致力于提供给程序员愉悦的开发体验。","COMPONENTS":{"__markdown":true}}